// Locking the offline copy at logout, instead of deleting it.
//
// Logging out only POSTed /api/logout and redirected; nothing touched the
// offline store. The boot probe treats an unreachable backend as "offline"
// and then serves the cached snapshot WITHOUT any authentication — that is
// the whole point of the feature. Together those two meant that after a
// logout, anyone who opened the app on that machine without a network saw
// the previous user's documents.
//
// Deleting the store on logout would fix it and break the feature: a
// technician who logs out routinely would lose the offline copy and have to
// re-download about 26 MB plus the files. So logout LOCKS instead. The data
// stays, access does not, and the next successful online sign-in unlocks it.
const lockKey = (t) => `od.offlineLocked.${t}`;

const ls = {
  get(k) { try { return localStorage.getItem(k); } catch { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch { /* ignore */ } },
  del(k) { try { localStorage.removeItem(k); } catch { /* ignore */ } },
};

/** Pure: does a stored value mean "locked"? Anything but the exact marker is
 *  unlocked, so a corrupted or half-written value fails OPEN — a lock that
 *  cannot be lifted would strand a user offline with no way back. */
export function isLockedValue(raw) {
  return raw === "1";
}

export function lockOffline(tenant) {
  if (!tenant) return false;
  ls.set(lockKey(tenant), "1");
  return true;
}

export function unlockOffline(tenant) {
  if (!tenant) return false;
  ls.del(lockKey(tenant));
  return true;
}

export function isOfflineLocked(tenant) {
  if (!tenant) return false;
  return isLockedValue(ls.get(lockKey(tenant)));
}
